import { ShuttleDetails } from './shuttle-details';

export type ShuttleSeatId = string;

export interface ShuttleSeat {
  isAvailable: boolean;
  seatId: ShuttleSeatId;
  seatNumber: string;
}

export interface ShuttleSelectedSeat extends Pick<ShuttleSeat, 'seatId' | 'seatNumber'> {
  rowLabel: string;
  scheduleId: string;
  seatMapId: string;
  sectionName: string;
  segment: number;
}

export interface ShuttleSelectedSeatWithoutSegmentInfo
  extends Omit<ShuttleSelectedSeat, 'scheduleId' | 'seatMapId' | 'segment'> { }

interface BuildShuttleSelectedSeats {
  seats: ShuttleSelectedSeat[];
  shuttleDetails: ShuttleDetails;
  passengersQ: number
}

const DEFAULT_SEGMENT = 0;

export const buildShuttleSelectedSeats = ({
  seats,
  shuttleDetails,
  passengersQ
}: BuildShuttleSelectedSeats): ShuttleSelectedSeat[][] => {
  const { name: scheduleId, seatMapId } = shuttleDetails.someDetails.trip.segments[DEFAULT_SEGMENT];

  const shuttleData = [];

  const seatsPerSegment = shuttleDetails.someDetails.trip.segments.map((segment, idx) => {
    return seats.filter((seat) => (seat.seatMapId === segment.seatMapId && seat.segment === idx && seat.scheduleId == segment.name));
  });

  for (let pax = 0; pax < passengersQ; pax++) {
    shuttleData.push(seatsPerSegment.map((map) => (map[pax])));
  }

  return shuttleData;


  return seats.map(({ rowLabel, seatId, seatNumber, sectionName }) => [
    {
      rowLabel,
      seatId,
      seatNumber,
      scheduleId,
      seatMapId,
      sectionName,
      segment: DEFAULT_SEGMENT,
    },
  ]);
};
